import { SelectedFilters } from "#modules/similarPart/view/filters/SelectedFilters";
import { FilterButton } from "#shared/view/components/FilterButton";
import { Stack } from "#shared/view/components/Stack";
import { FilterQuery } from "shared";

import { getHasFiltersParams } from "./getHasFiltersParams";

type Props = {
  filtersParams: FilterQuery;
  onUpdateFilters: (params: FilterQuery) => void;
  onSearch: () => void;
  hasDimensionsFilter: boolean;
};

export const Filters = ({
  filtersParams,
  onUpdateFilters,
  onSearch,
  hasDimensionsFilter,
}: Props) => {
  const hasFiltersParams = getHasFiltersParams(filtersParams);

  return (
    <Stack>
      <FilterButton
        filtersParams={filtersParams}
        updateFilters={onUpdateFilters}
        refetch={onSearch}
        hasDimensionsFilter={hasDimensionsFilter}
      />

      {hasFiltersParams && (
        <SelectedFilters
          filtersParams={filtersParams}
          removeFilter={onUpdateFilters}
          refetch={onSearch}
          hasDimensionsFilter={hasDimensionsFilter}
        />
      )}
    </Stack>
  );
};
